import React from 'react';
import { gql, useQuery } from '@apollo/client';

import { Button, useParams } from '../Navigation';
import {
  ApolloError,
  Center,
  Heading,
  LoadingIndicator,
  Progress,
  Text,
  VStack,
} from '../../core-ui';

import {
  GetJobProgress,
  GetJobProgressVariables,
  GetJobProgress_job as Job,
} from './__generated__/GetJobProgress';

const REFRESH_INTERVAL = 900;

const GET_JOB_PROGRESS = gql`
  query GetJobProgress($jobId: String!) {
    job(id: $jobId) {
      id
      email {
        id
        status
      }
      stats {
        total
        processed
        failed
      }
    }
  }
`;

function SendProgressPage(props: { job: Job }) {
  const { job } = props;
  const { stats } = job;
  return (
    <Center>
      <VStack maxW={800} align="stretch">
        {job.email.status === 'SENT' ? (
          <>
            <Heading textAlign="center">{t('Sent')}</Heading>
            <Text fontWeight="bold" textAlign="center">
              {t('Email Sent Successfully!')}
            </Text>
            <Button to={['/mailer/jobs/:id/summary', { id: job.id }]}>
              {t('Go to Summary')}
            </Button>
          </>
        ) : (
          <>
            <Heading textAlign="center">{t('Sending...')}</Heading>
            {stats.total > 0 ? (
              <>
                <Progress value={(stats.processed / stats.total) * 100} />
                <Text>
                  {t('Sent {processed} of {total}.', {
                    processed: stats.processed,
                    total: stats.total,
                  })}
                </Text>
              </>
            ) : null}
          </>
        )}
      </VStack>
    </Center>
  );
}

export default function SendProgressPageContainer() {
  const params = useParams();
  const jobId = params.id || '';
  const { data, error } = useQuery<GetJobProgress, GetJobProgressVariables>(
    GET_JOB_PROGRESS,
    {
      variables: { jobId },
      fetchPolicy: 'network-only',
      pollInterval: REFRESH_INTERVAL,
    },
  );
  if (error) {
    return <ApolloError error={error} />;
  }
  if (!data) {
    return <LoadingIndicator />;
  }
  if (!data.job) {
    return <Text>{t('Not Found')}</Text>;
  }
  return <SendProgressPage job={data.job} />;
}
